import ClaimEnquiry from "../../../model/claim-enquiry/ClaimEnquiry";
import analytics from "../../analytics";
import dataLayer from "../../tools/dataLayer";
import buildClaimEnquiryEventProperty from "../builders/claimEnquiry";
import { trackFutureFlightEnquiryCreated } from "../../../v2/modules/analytics/track";

const trackGoogleAnalyticsEvents = (claimEnquiry: ClaimEnquiry) => {
  const gaChannel = (claimEnquiry.channel || "").replace("ch_", "");
  const flightDate = claimEnquiry.disruptedFlight?.localDepartureDate;

  trackFutureFlightEnquiryCreated(flightDate);

  dataLayer.push({
    event: "GAEvent",
    eventCategory: "goals",
    eventAction: "submitted",
    eventLabel: `enquiry:${gaChannel}`,
  });

  if (claimEnquiry.isEligible) {
    dataLayer.push({
      event: "GAEvent",
      eventCategory: "goals",
      eventAction: "submitted",
      eventLabel: `valid enquiry:${gaChannel}`,
      eventValue: claimEnquiry.compensationDetails.serviceFeeAmount,
    });
    dataLayer.push({ event: "claim" });
  } else {
    dataLayer.push({
      event: "GAEvent",
      eventCategory: "goals",
      eventAction: "submitted",
      eventLabel: `invalid enquiry:${gaChannel}`,
    });
  }
};

const detectInvalidEnquiryType = (claimEnquiry: ClaimEnquiry) => {
  if (claimEnquiry.eligibilityCheckResult !== "undetermined") {
    return claimEnquiry.eligibilityCheckResult;
  } else if (claimEnquiry.airlineReason === "strike") {
    return "ineligible_user_strike";
  } else if (claimEnquiry.airlineReason === "weather") {
    return "ineligibile_user_weather";
  } else if (claimEnquiry.claimType === "cancelled") {
    return "ineligible_cancelled_delayed_less_than_two_hours";
  }
};

const trackCommonEvents = (claimEnquiry: ClaimEnquiry) => {
  if (claimEnquiry.isEligible) {
    analytics.track("validEnquiry", buildClaimEnquiryEventProperty(claimEnquiry));
  } else {
    analytics.track("invalidEnquiry", {
      invalidEnquiryType: detectInvalidEnquiryType(claimEnquiry),
      invalidEnquiryReason: claimEnquiry.eligibilityCheckResult,
    });
  }
};

const useClaimEnquiryCreatedEvent = () => {
  return (createdClaimEnquiry: ClaimEnquiry) => {
    trackGoogleAnalyticsEvents(createdClaimEnquiry);
    trackCommonEvents(createdClaimEnquiry);
  };
};

export default useClaimEnquiryCreatedEvent;
